import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { RedoJobButton } from "./RedoJobButton";
export const JobFailed = ({ job }) => {
  const history = useHistory();
  return (
    <div style={{ maxWidth: "50vw" }}>
      <Row className="text-center">
        <Col>
          <RedoJobButton job={job} />
          <div style={{ maxWidth: "20vw" }}>
            <div className="h2 m-4">
              <FontAwesomeIcon icon="times" color="red" />{" "}
              <span className="ml-2">Conversion failed</span>
            </div>
            <div className="">
              Your pages have been credited back. Our support team has been
              notified and is looking into it.
            </div>
            <div className="mt-4 d-flex flex-column align-items-center" style={{ gap: "0.75rem" }}>
              <Button
                variant="primary"
                onClick={() => history.push("/extractdata")}
              >
                Try another document
              </Button>
              <a
                href="mailto:support@docuclipper.com?subject=Job%20failed"
                className="btn btn-link btn-sm text-muted"
              >
                Contact support
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};
